import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App'

// CSS import order matters: index.css defines tokens + @theme; component
// files depend on those; mobile.css overrides must come last.
import '@/styles/index.css'
import '@/styles/components.css'
import '@/styles/layout.css'
import '@/styles/header.css'
import '@/styles/session.css'
import '@/styles/grapesjs.css'
import '@/styles/orders.css'
import '@/styles/tracking.css'
import '@/styles/sidebar.css'
import '@/styles/forms.css'
import '@/styles/cards.css'
import '@/styles/faq.css'
import '@/styles/exchange.css'
import '@/styles/omp.css'
import '@/styles/variants.css'
import '@/styles/icon-buttons.css'
import '@/styles/buttons.css'
import '@/styles/lifeline.css'
import '@/styles/bottom-sheet.css'
import '@/styles/chatbot.css'
import '@/styles/mobile.css'

const sentryDsn = import.meta.env.VITE_SENTRY_DSN
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.VITE_SENTRY_ENV || import.meta.env.MODE,
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACK_SAMPLE_RATE || '1.0'),
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
